<template>
  <v-tooltip right>
    <template v-slot:activator="{ on }">
      <v-layout row align-center v-on="on" style="flex-wrap: nowrap">
        <v-icon :color="getColor(state.main_color)">
          check_circle
        </v-icon>

        <v-icon
          v-if="state.secondary_warning"
          :color="getColor(state.secondary_warning_color)"
        >
          priority_high
        </v-icon>
      </v-layout>
    </template>

    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "ReservationStateIcon",

  props: {
    state: {
      type: Object,
      required: true
    }
  },

  computed: {
    tooltip() {
      let tooltip = this.state.main_description;
      tooltip += this.state.secondary_description
        ? ", " + this.state.secondary_description
        : "";

      return tooltip;
    }
  },

  methods: {
    getColor(color) {
      switch (color) {
        case "blue":
          return "accent";
        case "green":
          return "success";
        case "yellow":
          return "warning";
        case "red":
          return "error";
        default:
          return "grey";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetReservationManagement/Data/StateIcon.vue